
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
							<el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getMember" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item  style="float:right;">
					<el-button type="primary" @click="handleAdd">添加教练</el-button>
				</el-form-item>	
				<el-form-item  style="float:right;">
					<el-input  v-model="filters.Number"  @keyup.enter.native="getMember" placeholder="救生员编号"></el-input>
				</el-form-item>			
					<el-form-item  style="float:right;">
					<el-input  v-model="filters.LifeguardNumber"  @keyup.enter.native="getMember" placeholder="救生员资格证号" style="float:right;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getMember" placeholder="姓名" style="width:55%;float:right;"></el-input>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="Members" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60" hidden>
			</el-table-column> -->
			<el-table-column prop="Number" label="救生员编号" width="140" sortable>
			</el-table-column>
			<el-table-column prop="LifeguardNumber" label="教练员编号" width="160" sortable>
			</el-table-column>			
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Sex" label="性别" width="120" :formatter="formatSex" sortable>
			</el-table-column>	
			<el-table-column prop="Age" label="年龄" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="TeachingAge" label="教龄" width="120" sortable>
			</el-table-column>					
			<el-table-column prop="Phone" label="电话" width="150" sortable>
			</el-table-column>
			<el-table-column  label="照片" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="right" effect="light">
  				 <img v-if="scope.row.Image!=null"  @click="see(scope.row.Image)"  :src="scope.row.Image" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

                    </el-tooltip>
				</template>				
			</el-table-column>	
			<el-table-column  label="签章图" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="right" effect="light">
  				 <img v-if="scope.row.SealImage!=null"  @click="see(scope.row.SealImage)"  :src="scope.row.SealImage" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

                    </el-tooltip>
				</template>				
			</el-table-column>							
			<!-- <el-table-column prop="State" label="状态" min-width="90" :formatter="formatState" sortable>
			</el-table-column> -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>

			<el-table-column label="操作" min-width="430" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" type="primary" @click="exportShow(scope.row)">导出学员刷卡</el-button>
					<el-button size="small" type="primary" @click="imageShow(scope.$index, scope.row,'Photo')">上传照片</el-button>
					
					<el-button size="small" type="primary" @click="imageShow(scope.$index, scope.row,'Seal')">上传签章</el-button>

					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}位教练</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

        <el-dialog  title="导出月份时间" v-model="exportVisible" width="50%" >
			<el-form    label-width="120px"   @submit.native.prevent>							
				<el-form-item label="选择导出月份" >
					<el-date-picker style="width:100%" v-model="month" type="month" placeholder="选择月"></el-date-picker>
				</el-form-item>	
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="exportSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm" @submit.native.prevent>							
				<el-form-item label="救生员编号" prop="Number">
					<el-input v-model="editForm.Number" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="教练员编号" prop="LifeguardNumber">
					<el-input v-model="editForm.LifeguardNumber" auto-complete="off"></el-input>
				</el-form-item>					
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="性别">
					<el-radio-group v-model="editForm.Sex">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄" prop="Age">
					<el-input v-model="editForm.Age" auto-complete="off"></el-input>
				</el-form-item>		
				<el-form-item label="教龄" prop="TeachingAge">
					<el-input v-model="editForm.TeachingAge" auto-complete="off"></el-input>
				</el-form-item>																	
			    <el-form-item label="电话" prop="Phone">
					<el-input  v-model="editForm.Phone" auto-complete="off"></el-input>
				</el-form-item>	
			    <!-- <el-form-item label="照片" prop="Image">
					<el-input  v-model="editForm.Image" auto-complete="off"></el-input>
				</el-form-item>								 -->
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
        <el-dialog id="tt" title="照片上传" v-model="imageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>
			

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
				<el-form-item label="救生员编号" prop="Number">
					<el-input v-model="addForm.Number" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="教练员编号" prop="LifeguardNumber">
					<el-input v-model="addForm.LifeguardNumber" auto-complete="off"></el-input>
				</el-form-item>					
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="性别">
					<el-radio-group v-model="addForm.Sex">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄" prop="Age">
					<el-input v-model="addForm.Age" auto-complete="off"></el-input>
				</el-form-item>		
				<el-form-item label="教龄" prop="TeachingAge">
					<el-input v-model="addForm.TeachingAge" auto-complete="off"></el-input>
				</el-form-item>																	
			    <el-form-item label="电话" prop="Phone">
					<el-input  v-model="addForm.Phone" auto-complete="off"></el-input>
				</el-form-item>	
			    <!-- <el-form-item label="照片" prop="Image">
					<el-input  v-model="addForm.Image" auto-complete="off"></el-input>
				</el-form-item>								 -->
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
			    <!-- 查看图片 -->
        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {ExportStudent,getCoachList, removeCoach, addCoach,editCoach ,getMemberCount,UploadImage,UploadSeal } from '../../api/api';

	export default {
		data() {
			return {

				exportcoachName:'',
				exportcoachId:'',
				month:'',
				exportVisible:false,
				filters: {
					Name: '',
					LifeguardNumber:'',
					Number:''
				},
				seeImageVisible:false,
				fit:'contain',
				UploadImageUrl:'',
				UploadType:'',
				coachId:'',
				imageVisible:false,
				imgUrl:'',
				imgUrlShow:'',
				Count:0,
				options:[],
				Members:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
				},
				//编辑界面数据
				editForm: {
					id: 0,
					Name: '',
					Phone:'',
					Number:'',
					Remark:'',
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],									
				},
				//新增界面数据
				addForm: {
					Number:'',
					Name: '',
					LifeguardNumber:'',
					Phone:'',
					Remark:'',
					Sex:'',
					Age:'',
					TeachingAge:'',
					Image:'',
				}
			}
		},
		methods: {

            exportShow(row){
				 this.exportVisible=true;
				 this.exportcoachId=row.Id;
				 this.exportcoachName=row.Name;
			 },
            exportSubmit(){
				let para={
					Month:this.month,
					coachId:this.exportcoachId
				}
		   ExportStudent(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = this.exportcoachName+'-'+this.month; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })
			},				
				//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			see(imgUrl){
                     this.imgUrl=imgUrl;
                  this.seeImageVisible=true;
              },
		  image(imageStr)
		  {
			let  imgUrl="data:image/jpeg;base64,"+imageStr;
              return imgUrl;
		  },
			upload(param)
			{
				if(this.UploadType=="Photo")
				{
			    var fileObj=param.file;
			    console.log(param);

				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("coachId",this.coachId);
			  	UploadImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });
				}
				if(this.UploadType=="Seal")
				{
			    var fileObj=param.file;
			    console.log(param);

				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("coachId",this.coachId);
			  	UploadSeal(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });
				}
				

			},
			imageShow(index,row,type)
			{
				this.UploadType=type;
				this.coachId=row.Id;
			this.UploadImageUrl=UploadImage;
			// console.log("111"+upload);
			  this.imageVisible=true;
			  
			},
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getMember();
			},
			//获取用户列表
			getCount()
			{
			  
              let para={
			  };
			  getMemberCount(para).then((res)=>{
				  this.Count=res.data.ExtendData;
			  }).catch(error=>{
                 alert('网络错误');
                });
			},
			getMember() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					LifeguardNumber:this.filters.LifeguardNumber,
					Number:this.filters.Number
				};
				this.listLoading = true;
				//NProgress.start();
				getCoachList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.Members =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					console.log(res);
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeCoach(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					Number:'',
					Name: '',
					LifeguardNumber:'',
					Phone:'',
					Remark:'',
					Sex:'',
					Age:'',
					TeachingAge:'',
					Image:'',					
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							if(!(/^1[3456789]\d{9}$/.test(this.editForm.Phone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.editLoading = true;
							//NProgress.start();							
							let para = Object.assign({}, this.editForm);
						
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							editCoach(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								// console.log(res);
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getMember();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							if(!(/^1[3456789]\d{9}$/.test(this.addForm.Phone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.addLoading = true;
							//NProgress.start();
							let para= Object.assign({}, this.addForm);							
							// console.log(para);
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							addCoach(para).then((res) => {							
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.addFormVisible = false;
								this.getMember();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
								// this.$refs['addForm'].resetFields();

							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getMember();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// Coach.vue?eb66a6ea